import { Button, Form, Input } from 'antd';
import Col from 'antd/lib/col';
import styles from '../UserProfile.module.scss';

interface PersonalInfoFormProps {
  readOnly: boolean;
  editProfileUrl?: string;
}

export const PersonalInfoForm = ({
  readOnly,
  editProfileUrl,
}: PersonalInfoFormProps) => {
  return (
    <Col xs={24} md={24} lg={7}>
      <div className={styles.registerTitle}>{'Personal information'}</div>

      <Form.Item
        className={styles.registerFormItem}
        name='userId'
        label='E-mail'
      >
        <Input
          id='UserProfile-UserId_Input'
          placeholder=''
          disabled
          autoComplete='no'
        />
      </Form.Item>

      <div className={styles.personalFormNameField}>
        <Form.Item
          className={styles.registerFormItem}
          name='firstname'
          label='First name'
        >
          <Input
            id='UserProfile-FirstName_Input'
            placeholder=''
            disabled
            autoComplete='no'
          />
        </Form.Item>

        <Form.Item
          className={styles.registerFormItem}
          name='lastname'
          label='Last name'
        >
          <Input
            id='UserProfile-LastName_Input'
            placeholder=''
            disabled
            autoComplete='no'
          />
        </Form.Item>
      </div>

      <Form.Item className={styles.registerFormItem} name='phone' label='Phone'>
        <Input
          id='UserProfile-Phone_Input'
          autoComplete='no'
          placeholder=''
          disabled
        />
      </Form.Item>

      <Form.Item
        className={styles.registerFormItem}
        name='mobile'
        label='Mobile'
      >
        <Input
          id='UserProfile-Mobile_Input'
          autoComplete='no'
          placeholder=''
          disabled
        />
      </Form.Item>

      {!readOnly && editProfileUrl && (
        <Form.Item className={styles.registerFormItemButton} label={' '}>
          <a
            href={editProfileUrl}
            target='_blank'
            rel='noopener noreferrer'
            style={{ textDecoration: 'none' }}
          >
            <Button
              type='primary'
              id='UserProfile-EditPersonalInformation_Button'
              className={styles.submitBtn}
            >
              Edit personal information
            </Button>
          </a>
        </Form.Item>
      )}
    </Col>
  );
};
